<div class="hflex-200 overflow-hidden">
  <div class="vflex-300 fill-flex scrollable">
    <h2>Design Tokens</h2>
    <p>
      Tokens are used to semantically represent design decisions in a way that is customizable by
      themes. The two value columns show the light and dark variants of the theme family selected
      in the sidebar.
    </p>
    @if (vm(); as vm) {
      @if (customThemeActive()) {
        <p>
          A custom theme is currently applied — the table shows the stock values of the selected
          family, not the custom overrides.
        </p>
      }
      @for (category of vm.categories; track category.category) {
        <div class="vflex-300 surface-flat border-radius-200 pad-200">
          <h2 [attr.id]="category.category">{{ category.category }}</h2>
          <table>
            <tr class="centered">
              <th width="40%">Token</th>
              <th width="30%">{{ vm.light.name }}</th>
              @if (vm.dark) {
                <th width="30%">{{ vm.dark.name }}</th>
              }
            </tr>
            @for (row of category.tokens; track row.cssVar) {
              <tr>
                <th>{{ row.token }}</th>
                <td class="token-cell" [class]="vm.light.id">
                  @if (row.lightLabel !== null) {
                    <div class="sample" [style.background-color]="row.varRef"></div>
                    <p class="token-label">{{ row.lightLabel }}</p>
                  } @else {
                    <span class="mdw-notification-badge">N/D</span>
                  }
                </td>
                @if (vm.dark) {
                  <td class="token-cell" [class]="vm.dark.id">
                    @if (row.darkLabel !== null) {
                      <div class="sample" [style.background-color]="row.varRef"></div>
                      <p class="token-label">{{ row.darkLabel }}</p>
                    } @else {
                      <span class="mdw-notification-badge">N/D</span>
                    }
                  </td>
                }
              </tr>
            }
          </table>
        </div>
      }
    }
  </div>
  <aside
    id="tokens-sidebar"
    class="pad-300"
    pinnedSurfaceStyle="muted"
    [autoCollapse]="1440"
    [isCollapsed]="isCollapsed()"
    (isCollapsedChange)="isCollapsed.set($event)"
  >
    <h3>Table of Contents</h3>
    <ul>
      @if (vm(); as vm) {
        @for (category of vm.categories; track category.category) {
          <li href="tokens#{{ category.category }}">{{ category.category }}</li>
        }
      }
    </ul>
  </aside>
</div>
